import React, { useEffect, useState } from 'react';
import HeaderComponent from '../../../../components/header/Header.component';
import { useSearchParams } from 'react-router-dom';
import GenericHeader from '../../../../components/moduleCommonFormik/GenericHeader';
import { t } from 'i18next';
import Loading from '../../../../components/portalComponents/Loading.component';
import { Card } from 'react-bootstrap';
import SideCard from '../../../../components/moduleCommonFormik/SideCardGenericComponent';
import { Field, FormikProvider, useFormik } from 'formik';
import { endpoints, POST, requestInfo } from '../../../../services/modulesServices/userManagement.api';
import GenericCommonTextField from '../../../../components/moduleCommonFormik/GenericCommonTextField.component';
import { MORTGAGE_CHANGES_FINANCIAL_DETAILS } from '../../Mortgage Lessee/Mortgage.const';
import _ from 'lodash';
import GenericFileUploadField from '../../../../components/moduleCommonFormik/GenericFileUpload.component';
import StatusAlertPopup from '../../../../components/moduleCommonFormik/StatusAlertPopup';
import { cross } from '../../../../utils/Logo';
import { entityDocumentData } from '../../EstateManagement/LeaseDeed/LeaseDeed.controller';

const MortgageView = () => {
    const [searchParams] = useSearchParams();
    const plotId = searchParams.get('plotId');
    const entityId = searchParams.get('entityId') ? searchParams.get('entityId') : JSON.parse(localStorage.getItem('user') || '{}')?.entityId;
    const stepsDetails = [{ titleCode: 'MORTGAGE_DETAILS', name: 'Mortgage Details', index: 1, isActive: true }];

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [modalDetails, setModalDetails] = useState<any>({});

    const formik = useFormik<any>({
        initialValues: {
            isUpdatable: false
        },
        onSubmit: () => {}
    });

    const { values, setValues } = formik;

    useEffect(() => {
        (async () => {
            try {
                setIsLoading(true);
                const { data: mortgageData } = await POST(endpoints?.searchMortgage + `?statusList=OPEN,APPROVED&entityIds=${entityId}&plotIds=${plotId}`, { RequestInfo: requestInfo() });

                const tempMortgageDetails = await Promise.all(
                    mortgageData?.MortgageDetails?.map(async (val: any) => {
                        const bankMortgageDetails = await Promise.all(
                            val?.bankMortgageDetails?.map(async (item: any) => {
                                if (item.status === 'CURRENT') {
                                    const bankLetterDoc = item?.bankRefId && (await entityDocumentData(item?.bankRefId));
                                    return { ...item, bankLetter: bankLetterDoc?.[0] };
                                }
                                return null; // Return null for items that don't meet the condition
                            }) || []
                        );

                        return {
                            ...val,
                            bankMortgageDetails: bankMortgageDetails.filter(Boolean)
                        };
                    }) || []
                );
                setValues((val: any) => ({ ...val, mortgageDetails: tempMortgageDetails }));
                setIsLoading(false);
            } catch (e: any) {
                setIsLoading(false);
                let errMsg = e.response?.data?.errorMessage || e.response?.data?.Errors?.[0]?.message || t('SOMETHING_WENT_WRONG', 'Something went wrong!');
                setModalDetails({ show: true, title: 'Error!', para: errMsg, img: cross, type: 'error', reUpload: 'OK' });
            }
        })();
    }, []);

    const handleStepClick = () => {};

    const handleModalClose = () => {
        setModalDetails({});
    };

    console.log('formik', formik);

    return (
        <div>
            <HeaderComponent />
            {isLoading ? (
                <Loading />
            ) : (
                <div className='employee-creation-container bg-light m-auto px-5 py-4 row'>
                    <GenericHeader text={t('VIEW_MORTGAGE', 'View Mortgage')} />
                    <div className='col-3 stickyCard-section'>
                        <div className='stickyCard' style={{ top: '110px' }}>
                            <GenericHeader sideHeader={true} text={t('VIEW_MORTGAGE', 'View Mortgage')} />
                            <Card className='card_border p-3'>
                                <Card.Body>
                                    <Card.Text className=' d-flex flex-column  row-gap-3'>
                                        <SideCard steps={stepsDetails} visited={true} activeIndex={1} handleStepClick={handleStepClick} indexType={'alphabets'} />
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </div>
                    </div>
                    <div className='col-9 form-section'>
                        <FormikProvider value={formik}>
                            <Card className='card_border'>
                                <Card.Body>
                                    {values?.mortgageDetails?.length ? (
                                        <>
                                            {values?.mortgageDetails?.map((val: any, index: number) => {
                                                return (
                                                    <div className={`col-sm-12 collapsible_box noting-collapsible-box align-items-center py-3 px-0`}>
                                                        <div className='font-inter fw-700 font-24 px-4 project-primary-color'>{`${t('MORTGAGE_DETAILS', 'Mortgage Details')} - ${index + 1}`}</div>
                                                        <div className='px-2'>
                                                            <div className='col-6 p-3'>
                                                                <GenericCommonTextField
                                                                    field={`mortgageDetails.${index}.typeDisplayName`}
                                                                    title={t('MORTGAGE_TYPE', 'Mortgage Type')}
                                                                    isDisabled={true}
                                                                />
                                                            </div>
                                                            {val?.bankMortgageDetails?.length ? (
                                                                <>
                                                                    {val?.bankMortgageDetails?.map((item: any, ind: number) => {
                                                                        return (
                                                                            <>
                                                                                <div className='formTitle m-0 p-3'>{`${t('BANK_DETAILS', 'Bank Details')} - ${ind + 1}`}</div>
                                                                                <div className='row d-flex m-0'>
                                                                                    {MORTGAGE_CHANGES_FINANCIAL_DETAILS[0]?.formData.map((formField: any, id: number) => (
                                                                                        <div className={`p-3 col-sm-6`} key={id}>
                                                                                            <label htmlFor={`bankDetails.${ind}.${formField.field}`} className='pb-2 file-form-label'>
                                                                                                {formField.title} - {ind + 1}
                                                                                            </label>
                                                                                            <Field
                                                                                                name={`${ind}.${formField.field}`}
                                                                                                type={'text'}
                                                                                                id={`${ind}.${formField.field}`}
                                                                                                className={` form-control was-validated`}
                                                                                                value={_.get(values, `mortgageDetails.${index}.bankMortgageDetails.${ind}.${formField.field}`)}
                                                                                                disabled={true}
                                                                                            />
                                                                                        </div>
                                                                                    ))}
                                                                                    <div className='col-6 p-3'>
                                                                                        <GenericFileUploadField
                                                                                            field={`mortgageDetails.${index}.bankMortgageDetails.${ind}.bankLetter`}
                                                                                            title={`Bank Letter`}
                                                                                            entityFileData={{
                                                                                                documentNamePrefix: `${_.get(values, `mortgageDetails.${index}.bankMortgageDetails.${ind}.bankName`)}_Bank Letter `,
                                                                                                documentType: ''
                                                                                            }}
                                                                                            isDisabled={true}
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            </>
                                                                        );
                                                                    })}
                                                                </>
                                                            ) : (
                                                                <></>
                                                            )}
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </>
                                    ) : (
                                        <></>
                                    )}
                                </Card.Body>
                            </Card>
                        </FormikProvider>

                        <StatusAlertPopup
                            title={modalDetails.title}
                            para={modalDetails.para}
                            img={modalDetails.img}
                            show={modalDetails.show}
                            handleClose={() => handleModalClose()}
                            type={modalDetails.type}
                            reUpload={modalDetails.reUpload}
                            handleSubmit={() => handleModalClose()}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default MortgageView;
